import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgApexchartsModule } from 'ng-apexcharts';
import { QuillModule } from 'ngx-quill';
import { CoreCommonModule } from 'src/@core/common.module';
import { CorePipesModule } from 'src/@core/pipes/pipes.module';
import { DirectivesModule } from '../directives/directives.module';
import { AddComponent } from '../modules/hr360/attendance/add/add.component';
import { TimeTrackingComponent } from '../modules/i-team/tasks/time-tracking/time-tracking.component';
import { UatTicketAddComponent } from '../modules/lead-konnekt/tickets/add-for-uat/add-for-uat.component';
import { AvatarComponent } from './avatar/avatar.component';
import { DashboardCountCardComponent } from './dashboard-count-card/dashboard-count-card.component';
import { DashboardDeadlinesCardComponent } from './dashboard-deadlines-card/dashboard-deadlines-card.component';
import { DashboardTeamCardComponent } from './dashboard-team-card/dashboard-team-card.component';
import { DashboardTodyCardComponent } from './dashboard-tody-card/dashboard-tody-card.component';
import { FileLayoutComponent } from './file-layout/file-layout.component';
import { NineIconsComponent } from './nine-icons/nine-icons.component';
import { SecondNavbarComponent } from './second-navbar/second-navbar.component';
import { StatusPopoverComponent } from './status-popover/status-popover.component';
import { TimeTrackingButtonComponent } from './time-tracking-button/time-tracking-button.component';
import { WarningModalComponent } from './warning-modal/warning-modal.component';
import { LoanStatusPopoverComponent } from './loan-status-popover/loan-status-popover.component';
import { PMSFilterDropdownComponent } from './pms-filter-dropdown/pms-filter-dropdown.component';
import { TasksPipeModule } from '../modules/i-team/tasks/pipe/tasks-pipes.module';
import { CandidateStatusPopoverComponent } from './candidate-status-popover/candidate-status-popover.component';
import { EmployeeStatusCardComponent } from './employee-status-card/employee-status-card.component';
import { ImportModalComponent } from './import-modal/import-modal.component';
import { EncashmentStatusPopoverComponent } from './encashment-status-popover/encashment-status-popover.component';
import { ReportCardComponent } from './report-card/report-card.component';
import { ClaimStatusPopoverComponent } from './claim-status-popover/claim-status-popover.component';
import { HistoryPopoverComponent } from './history-popover/history-popover.component';

@NgModule({
  declarations: [
    AvatarComponent,
    DashboardCountCardComponent,
    FileLayoutComponent,
    DashboardTeamCardComponent,
    DashboardTodyCardComponent,
    DashboardDeadlinesCardComponent,
    TimeTrackingButtonComponent,
    AddComponent,
    TimeTrackingComponent,
    WarningModalComponent,
    UatTicketAddComponent,
    SecondNavbarComponent,
    NineIconsComponent,
    StatusPopoverComponent,
    LoanStatusPopoverComponent,
    PMSFilterDropdownComponent,
    CandidateStatusPopoverComponent,
    EmployeeStatusCardComponent,
    ImportModalComponent,
    EncashmentStatusPopoverComponent,
    ReportCardComponent,
    ClaimStatusPopoverComponent,
    HistoryPopoverComponent,
  ],
  imports: [
    CommonModule,
    NgApexchartsModule,
    RouterModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    QuillModule,
    CorePipesModule,
    CoreCommonModule,
    DirectivesModule,
    TasksPipeModule,
  ],
  exports: [
    AvatarComponent,
    DashboardCountCardComponent,
    FileLayoutComponent,
    DashboardTeamCardComponent,
    DashboardTodyCardComponent,
    DashboardDeadlinesCardComponent,
    TimeTrackingButtonComponent,
    AddComponent,
    TimeTrackingComponent,
    WarningModalComponent,
    UatTicketAddComponent,
    SecondNavbarComponent,
    NineIconsComponent,
    StatusPopoverComponent,
    LoanStatusPopoverComponent,
    PMSFilterDropdownComponent,
    CandidateStatusPopoverComponent,
    EmployeeStatusCardComponent,
    ImportModalComponent,
    EncashmentStatusPopoverComponent,
    ReportCardComponent,
    ClaimStatusPopoverComponent,
    HistoryPopoverComponent,
  ],
})
export class ComponentsModule { }
